<mat-form-field [formGroup]="formGroup"
                class="app-select no-search nc-select"
                [appearance]="appearance">
  <mat-label>{{label | translate}}{{requiredAsterix}}</mat-label>
  <mat-select *ngIf="!isReadonly"
              [id]="'nc-select-' + id"
              [formControl]="selectControl"
              [multiple]="multiple"
              [compareWith]="comparisonFunction"
              (openedChange)="openChange($event)">

    <mat-select-trigger class="select-trigger">
      {{translate ? (selectedDataText | translate) : selectedDataText}}
      <span (click)="reset($event)" class="remove-select-icon">
            <mat-icon [id]="'nc-select-icon-' + clearIconId" *ngIf="selectedDataText != '' && removeSelected" class="remove-select">clear</mat-icon>
      </span>
    </mat-select-trigger>
    <nc-mat-select-search-input [formControl]="filterControl"
                                [noEntriesFoundLabel]="searchNoEntriesFoundLabel"
                                [placeholderLabel]="searchPlaceholderLabel | translate"
                                [searchTextId]="searchTextId"
                                [buttonId]="searchButtonId"
                                [class]="searchable ? '' : 'select-search-hidden'">
    </nc-mat-select-search-input>

    <ng-template #multipleOptions>
      <cdk-virtual-scroll-viewport itemSize="10" class="app-select-viewport">
        <mat-option *ngIf="enableSelectAll" [value]="0">{{'showAll' | translate}}</mat-option>
        <mat-option *cdkVirtualFor="let item of selectData$ | async" [value]="item.value">
          {{translate ? (item.text | translate) : item.text}}
        </mat-option>
      </cdk-virtual-scroll-viewport>
    </ng-template>
    <cdk-virtual-scroll-viewport *ngIf="!multiple else multipleOptions" itemSize="10" class="app-select-viewport">
      <mat-option *cdkVirtualFor="let item of selectData$ | async" [value]="item.value">
        {{translate ? (item.text | translate) : item.text}}
      </mat-option>
    </cdk-virtual-scroll-viewport>
  </mat-select>

  <input matInput [readonly]="isReadonly" [formGroup]="formGroup" *ngIf="isReadonly" [value]="selectedDataText | translate"
         [id]="'nc-select-readonly-' + id">
  <mat-error *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</mat-form-field>
